import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import assistanceApi from "../../api/assistance";
import {
  IAssistanceDocumentListFilterType,
  IAssistanceDocumentListState,
  selectAssistanceDocumentList,
} from ".";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";
import { addDays, formatISO } from "date-fns";

export function getAssistanceDocumentList(
  assistanceId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectAssistanceDocumentList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(
      actions.assistanceDocumentListFetchRequest(newState.newCountState)
    );
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);
      addParams(params, state);

      const documents = await assistanceApi.getAssistanceDocumentList(
        assistanceId,
        {
          params,
          cancelToken,
        }
      );
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, documents);

      dispatch(
        actions.assistanceDocumentListFetchSuccess({
          data: documents.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.assistanceDocumentListFetchError(
          cancelToken.reason !== undefined
        )
      );
    }
  };
}

export function getAssistanceDocumentListCount(
  assistanceId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectAssistanceDocumentList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.assistanceDocumentListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      addParams(params, state);
      const count = await assistanceApi.getAssistanceDocumentCount(
        assistanceId,
        {
          params,
          cancelToken,
        }
      );
      cancelToken.throwIfRequested();

      dispatch(actions.assistanceDocumentListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.assistanceDocumentListCountError(
          cancelToken.reason !== undefined
        )
      );
    }
  };
}

export function changeAssistanceDocumentListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.assistanceDocumentListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeAssistanceDocumentListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.assistanceDocumentListChangePage(page));
  };
}

export function changeAssistanceDocumentListFilter(
  filter: IAssistanceDocumentListFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.assistanceDocumentListChangeFilter(filter));
  };
}

export function assistanceDocumentListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectAssistanceDocumentList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.assistanceDocumentListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.assistanceDocumentListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}

function addParams(
  params: URLSearchParams,
  state: IAssistanceDocumentListState
) {
  if (state.filter!.createdFrom) {
    params.append("CreatedFrom", formatISO(state.filter!.createdFrom));
  }
  if (state.filter!.createdTo) {
    params.append("CreatedTo", formatISO(addDays(state.filter!.createdTo, 1)));
  }
  if (state.filter!.lastEditFrom) {
    params.append("LastEditFrom", formatISO(state.filter!.lastEditFrom));
  }
  if (state.filter!.lastEditTo) {
    params.append(
      "LastEditTo",
      formatISO(addDays(state.filter!.lastEditTo, 1))
    );
  }
  if (state.filter!.authorId) {
    params.append("IdAuthor", state.filter!.authorId.toString());
  }
  if (state.filter!.lastEditorId) {
    params.append("IdLastEditor", state.filter!.lastEditorId.toString());
  }
}
